function displayNoReviewsText(shouldDisplay, reviewCount) {
  return shouldDisplay && reviewCount !== void 0 && reviewCount === 0;
}
const COMPONENT_NAME = "Rating";
const INVALID_PROPS_ERROR = `${COMPONENT_NAME}-error: Missing required parameter`;
const DEFAULT_MAX_STARS = 5;
const DEFAULT_MAX_STARS_WHEN_EMPTY = 1;
export {
  COMPONENT_NAME,
  DEFAULT_MAX_STARS,
  DEFAULT_MAX_STARS_WHEN_EMPTY,
  INVALID_PROPS_ERROR,
  displayNoReviewsText
};
